import { yupResolver } from '@hookform/resolvers/yup';
import { TournamentPlayerRole, TournamentPlayerStatus } from '@okletsplay/core';
import { sessionSelector } from 'app/store/session/selectors';
import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { createJoinTournamentTeamValidationSchema } from './join-tournament-team-validation-schema';
import { JoinTournamentTeamFormFields } from 'modules/tournaments/interfaces/forms';
import { useForm, UseFormReturn } from 'react-hook-form';
import { capitalize } from 'lodash';

interface UseJoinTournamentTeamFormHook {
  form: UseFormReturn<JoinTournamentTeamFormFields>;
  resetToDefault: () => void;
}

export const useJoinTournamentTeamForm = (
  maxSize: number,
  withPassphrase: boolean,
  singlePlayer = false
): UseJoinTournamentTeamFormHook => {
  const currentUser = useSelector(sessionSelector.activeUser);

  const defaultTournamentTeam = useMemo(
    () => ({
      name: singlePlayer ? capitalize(currentUser.userName) : '',
      passphrase: '',
      players: [
        {
          role: TournamentPlayerRole.Captain,
          status: TournamentPlayerStatus.Standby,
          user: currentUser,
          userId: currentUser?.userId,
        },
      ],
      isRewardBalanceSelected: false,
    }),
    [currentUser, singlePlayer]
  );

  const formResolver = yupResolver(
    createJoinTournamentTeamValidationSchema(maxSize, withPassphrase)
  );
  const form = useForm<JoinTournamentTeamFormFields>({
    mode: 'onChange',
    resolver: formResolver,
    defaultValues: defaultTournamentTeam,
  });

  const resetToDefault = useCallback(() => {
    form.reset(defaultTournamentTeam);
  }, [defaultTournamentTeam, form]);

  return {
    form,
    resetToDefault,
  };
};
